// extracted by mini-css-extract-plugin
export default {"holidayTypePagePillButtons":"HolidayType_holidayTypePagePillButtons__Mx1La"};